/**
 * Estilo dark do Google Maps (JSON `styles`): recolore o mapa PADRÃO em tom escuro
 * SEM esconder nada — mantém tudo que o light mostra (nomes de cidade, ícones, POIs,
 * estradas locais, transit, divisões estaduais), só que com paleta escura. Terra em
 * slate escuro neutro (SEM verde), oceano azul-escuro, labels claros.
 *
 * Regra de ouro: NÃO usar `visibility: 'off'` aqui — só recolorir. Esconder feature foi
 * o que sumia com nome de cidade/ícone e deixava o dark "mais pobre" que o light.
 *
 * Aplicado via `styles` nas opções do mapa. Só funciona enquanto o mapa NÃO usa
 * `mapId` (nesse caso o Google ignora `styles` e o estilo passa a ser cloud-based).
 */
export const DARK_MAP_STYLE: google.maps.MapTypeStyle[] = [
  {elementType: 'geometry', stylers: [{color: '#181e24'}]},
  {elementType: 'labels.text.fill', stylers: [{color: '#c8d2d8'}]},
  {elementType: 'labels.text.stroke', stylers: [{color: '#0c130f'}]},
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{color: '#242c34'}]
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [{color: '#4c5763'}]
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [{color: '#242c34'}]
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d5dde2'}]
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels.text.fill',
    stylers: [{color: '#98a3ab'}]
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{color: '#181e24'}]
  },
  {
    // Vegetação/floresta na MESMA cor da terra: mata o verde, tudo escuro neutro
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry',
    stylers: [{color: '#181e24'}]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [{color: '#20282e'}]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{color: '#1e262c'}]
  },
  {
    // Labels de POI (nomes de reserva/parque + os pequenos círculos): escondidos pra
    // reduzir poluição. Nomes de CIDADE não são poi (são administrative.locality) e ficam.
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{visibility: 'off'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{color: '#20292f'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{visibility: 'off'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#2a333c'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{color: '#161d24'}]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9aa6af'}]
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{color: '#313b45'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{color: '#3f4c59'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{color: '#212a33'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{color: '#c2cbd2'}]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{color: '#2a333c'}]
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9aa6af'}]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{color: '#0b141d'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{color: '#5b7fa0'}]
  }
];

/**
 * Estilo light do Google Maps: par do {@link DARK_MAP_STYLE}. Array vazio = estilo
 * PADRÃO do Google (terreno verde, água azul, POIs e labels visíveis) — o mesmo visual
 * clássico do mapa. É o modo inicial da aplicação.
 */
export const LIGHT_MAP_STYLE: google.maps.MapTypeStyle[] = [];
